const getInitialSearchQuery = ({
  sharedSearchQuery,
  isTextEditingSource,
  initialActiveSection,
  sections,
}) => {
  if (sharedSearchQuery) {
    return sharedSearchQuery;
  }

  if (!isTextEditingSource) {
    return '';
  }

  return sections.find(({ id }) => id === initialActiveSection).title;
};

export default getInitialSearchQuery;
